import {
    ShieldCheck,
    BadgeCheck,
    Building2,
    TrendingUp,
    KeyRound,
    Handshake,
} from "lucide-react";
import { site } from "@/data/site";
import { Reveal } from "./Reveal";

const ICONS = {
    ShieldCheck,
    BadgeCheck,
    Building2,
    TrendingUp,
    KeyRound,
    HandshakeIcon: Handshake,
};

export const WhySwastik = () => {
    return (
        <section
            id="why"
            data-testid="why-section"
            className="bg-ivory px-6 py-16 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="mb-14 flex flex-col items-center text-center lg:mb-20">
                        <span className="eyebrow">Why Swastik Realty</span>
                        <h2 className="mt-5 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-charcoal sm:text-5xl">
                            The assurance behind every address.
                        </h2>
                    </div>
                </Reveal>

                <div className="grid gap-px overflow-hidden border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
                    {site.why.map((item, i) => {
                        const Icon = ICONS[item.icon] || ShieldCheck;
                        return (
                            <Reveal key={item.title} delay={(i % 3) * 0.08}>
                                <div
                                    data-testid={`why-card-${i}`}
                                    className="group h-full bg-ivory p-9 transition-colors duration-500 hover:bg-sand lg:p-11"
                                >
                                    <div className="flex h-14 w-14 items-center justify-center border border-champagne/60 text-orange transition-colors duration-500 group-hover:bg-orange group-hover:text-white">
                                        <Icon size={24} strokeWidth={1.4} />
                                    </div>
                                    <h3 className="mt-7 font-serif text-2xl text-charcoal">
                                        {item.title}
                                    </h3>
                                    <p className="mt-3 text-base leading-relaxed text-slatey">
                                        {item.body}
                                    </p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
